import React, { FC } from 'react';
import { shareLink26794, ShareLinkType26794 } from 'src/utils/shareLink';
import { useSelector } from 'react-redux';
import { commonSelector } from 'src/store/commonPart/selector';
import { UiButton } from 'src/components/UI/Button';
import facebookImg from 'src/assets/images/fbNewLogo.svg';
import linkedInImg from 'src/assets/images/linkedIn.svg';
import twitterImg from 'src/assets/images/twitterNewLogo.svg';
import emailImg from 'src/assets/images/mailLogo.svg';
import linkImg from 'src/assets/images/linkLogo.svg';
import mobileSharingImg from 'src/assets/images/mobileSharingIcon.svg';

type Props = {
  sharinkLink: string;
  MobileSharingTitle: string;
  MobileSharingText: string;
  EmailSubject: string;
  EmailBody: string;
  TextToGiveKeyWord?: string | null;
  InternationalNumbersEnabled?: boolean;
};

export const ShareIcons: FC<Props> = ({
  sharinkLink,
  MobileSharingTitle,
  MobileSharingText,
  EmailSubject,
  EmailBody,
  TextToGiveKeyWord,
  InternationalNumbersEnabled,
}) => {
  const links: ShareLinkType26794[] = ['Link', 'Facebook', 'Twitter', 'LinkedIn', 'Email'];
  const { innerWidth } = useSelector(commonSelector);
  const MOBILE_WIDTH = 430;
  const isMobile = innerWidth <= MOBILE_WIDTH;

  const shareIcons: Record<ShareLinkType26794, string> = {
    Facebook: facebookImg,
    Twitter: twitterImg,
    Link: linkImg,
    LinkedIn: linkedInImg,
    Email: emailImg,
    Mobile: '',
  };

  return (
    <div className="socials-icons-wrapper">
      {!isMobile ? (
        links.map((type) => (
          <UiButton
            key={type}
            tag="a"
            effects
            className="bicolor-ico btn-floating display-inline-flex"
            onClick={() => {
              shareLink26794(
                type,
                sharinkLink,
                undefined,
                undefined,
                EmailBody,
                EmailSubject,
                TextToGiveKeyWord,
                InternationalNumbersEnabled
              );
            }}
          >
            <img src={shareIcons[type]} alt={type} />
          </UiButton>
        ))
      ) : (
        <UiButton
          tag="a"
          effects
          className="bicolor-ico btn-floating display-inline-flex mobile-share-button"
          onClick={() => {
            shareLink26794('Mobile', sharinkLink, MobileSharingTitle, MobileSharingText);
          }}
        >
          <img src={mobileSharingImg} alt="Share" />
        </UiButton>
      )}
    </div>
  );
};
